import {$authHost} from "./index";

export const fetchRequestChatMessages = async ({ limit = 80, beforeId = null } = {}) => {
    const { data } = await $authHost.get('api/requestChat/messages', {
        params: {
            limit,
            ...(beforeId ? { beforeId } : {})
        }
    });

    return data;
};

export const sendRequestChatMessage = async (payload) => {
    const body = typeof payload === "string"
        ? { content: payload }
        : payload;

    const { data } = await $authHost.post('api/requestChat/message', body);

    return data;
};

export const publishRequestToChat = async (payload) => {
    const { data } = await $authHost.post('api/requestChat/admin/request', payload);
    return data;
};

export const fetchRequestOffers = async (requestId) => {
    const { data } = await $authHost.get(
        `api/requestChat/admin/requests/${requestId}/offers`
    );

    return data;
};

export const fetchMyRequestChatAdds = async () => {
    const { data } = await $authHost.get('api/requestChat/my-adds');
    return data;
};

export const fetchRequestChatUnread = async () => {
    const { data } = await $authHost.get('api/requestChat/unread');
    return data;
};

export const markRequestChatRead = async () => {
    const { data } = await $authHost.post('api/requestChat/read');
    return data;
};